import * as React from 'react';
import { Box, TextField, Grid, Button, Collapse, Alert } from '@mui/material';
import { useState } from 'react';
// import { useRef } from 'react';
// import emailjs from '@emailjs/browser';

export default function Contactform() {
    const [wasSend, setWasSend] = useState(false);
    const [wasSuccessfully, setWasSuccessfully] = useState(true);
    const [toOftenTry, setToOftenTry] = useState(false);
    const [currentContact, setCurrentContact] = useState({
        FirstName: "",
        LastName: "",
        Email: "",
        Company: "",
        Message: ""
    });

    const handleChange = (event) => {
        let tmpObject = { ...currentContact };
        tmpObject[event.target.name] = event.target.value;
        setCurrentContact(tmpObject);
    };

    async function handleClickSend() {
        setWasSuccessfully(true);
        setWasSend(false);
        setToOftenTry(false);

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(currentContact)
        };
  
        fetch('/kemto_mail.php', requestOptions)
            .then(res => {
                if (res.status === 200) return res.json();
                else if (res.status === 423) throw Error("Too many attempts.");
                else throw Error(res.Error);
            })
            .then(() => {
                setCurrentContact({ FirstName: "", LastName: "", Email: "", Company: "", Message: "" });
                setWasSend(true);
            })
            .catch(error => {
                if (error.message === "Too many attempts.") {
                    setToOftenTry(true);
                } else {
                    setWasSuccessfully(false);
                }
            });
    }

    async function handleSubmit(e) {
        e.preventDefault();
        handleClickSend();
        e.target.reset();
    }

    return (
        <Box className="contactWrapper">

<Box className='contactBottomWrapper'>
                {/* <form action="contact.php"> */}
                {/* <form ref={form} onSubmit={sendEmail}> */}
                <form onSubmit={handleSubmit}>

                        <Grid item xs={12} sm={12} className='contactInputWrapper'>
                            <TextField type="text" required id="nachname" name='LastName' onChange={handleChange} label="Name" variant="standard" className='contactInput' />
                        </Grid>

                    <Grid item xs={12} sm={12} className='contactInputWrapper'>
                            <TextField type="tel" required id="company" name='Company' onChange={handleChange} label="Company" variant="standard" className='contactInput' />
                        </Grid>

                        <Grid item xs={12} sm={12} className='contactInputWrapper'>
                            <TextField type="email" required id="email" name='Email' onChange={handleChange} label="E-Mail" variant="standard" className='contactInput' />
                        </Grid>

 
                        <Grid item xs={12} sm={12} className='contactInputWrapper'>
                            <TextField id="nachricht" name='Message' onChange={handleChange} label="Message" multiline rows={4} variant="standard" className='contactInput' />
                        </Grid>

                    <Box className='contactFormTopGrid' id="contactFormBottomControls">
                    <p className='contactInfoText'>Please take note of our <a href="/datenschutz" >privacy policy</a>.</p>
                        <Grid item xs={12} sm={4}>
                            <Button variant='contained' color='primary' className='contactFormBtn' type="submit" id="submitBtn">Send</Button>
                        </Grid>
                    </Box>
                </form>
            </Box>


            <Collapse key="error-send" in={!wasSuccessfully}>
                <Alert severity='error'>
                There was an error sending the data. Please try again or contact us by phone.
                </Alert>
            </Collapse>

            <Collapse key="success-send" in={wasSend}>
                <Alert severity='success'>
                Your request has been successfully submitted! We will get back to you as soon as possible.
                </Alert>
            </Collapse>

            <Collapse key="locked-send" in={toOftenTry}>
                <Alert severity='warning'>
                You have already sent two requests within an hour!
                </Alert>
            </Collapse>


            <Box>
                <Grid container spacing={2} id="formMessageBox">
                    <Grid item xs={12} sm={12}>
                        <p id="formsuccess"> Your request has been successfully submitted! We will get back to you as soon as possible.</p>
                        <p id="formFail">There was an error sending the data. Please try again or contact us by phone.</p>
                    </Grid>
                </Grid>

            </Box>

        </Box >

    );
}